<template>
  <v-dialog v-model="openTranDetail" width="800" persistent>
    <v-card>
      <v-card-title class="headline colorHeadlineStandard" primary-title>
        {{ $t('label.detail') }}
        <v-spacer />
        <v-icon large @click="openTranDetail = false">{{ mdiClose }}</v-icon>
      </v-card-title>
      <v-card-text>
        <v-sheet class="pt-4" height="300">
          <v-row>
            <v-col cols="6">
              <v-simple-table height="200" dense fixed-header>
                <thead>
                  <tr>
                    <th class="text-left">{{ $tc('label.printTemplate') }}</th>
                    <th class="text-left">{{ $tc('label.date') }}</th>
                    <!--th class="text-left" width="40">{{ $tc('label.status') }}</th-->
                    <th class="text-left" width="50">{{ $tc('label.show') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in tranDocs" :key="item.id">
                    <td>{{ item.templateName }}</td>
                    <td>{{ formatDate(item.signTime, $store.state.auth.df.date) }}</td>
                    <td>
                      <v-btn icon @click="getVisitorDocument(item.id)">
                        <v-icon>{{ mdiPrinter }}</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col cols="6" v-if="parentTran.iwpMandatory > 0">
              <div class="mt-1 ml-4">
                <v-row>
                  <v-col class="pb-0">{{ $t('label.iwpRecord') }}</v-col>
                </v-row>
              </div>
              <div v-if="childTran === undefined" class="mt-2 ml-4">
                <v-row>
                  <v-col cols="3" class="pb-0">
                    <b>{{ $tc('label.area', 1) }}:</b>
                  </v-col>
                  <v-col cols="4" class="pb-0">
                    {{ parentTran.area.name }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pt-0">
                    <b>{{ $t('label.iwpNoRecord') }}:</b>
                  </v-col>
                </v-row>
              </div>
              <div v-else class="mt-2 ml-4">
                <v-row>
                  <v-col cols="3" class="pb-0">
                    <b>{{ $tc('label.area', 1) }}:</b>
                  </v-col>
                  <v-col cols="4" class="pb-0">
                    {{ parentTran.area.name }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="py-0">
                    <b>{{ $t('label.enter') }}:</b>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    {{ formatDate(childTran.timeenter, $store.state.auth.df.dateTime) }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="py-0">
                    <b>{{ $t('label.exit') }}:</b>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    {{ formatDate(childTran.timeexit, $store.state.auth.df.dateTime) }}
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-sheet>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn v-if="tranSignStatus == 1 || tranSignStatus == 3" color="red" @click="deleteConfirm = true">{{
          $t('btn.deleteRecord')
        }}</v-btn>
        <v-btn v-if="tranSignStatus == 3" color="colorStnBtn1" @click="requestConfirmAgain()">{{ $t('btn.confirmAgain') }}</v-btn>
      </v-card-actions>
    </v-card>
    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.confirmDelete')}?`"
      :openDialog.sync="deleteConfirm"
      v-on:confirm="deleteTransaction"
    />
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import { mdiCheck, mdiPrinter, mdiClose } from '@mdi/js';
import { DefaultComputed } from 'vue/types/options';
import DialogConfirmDelete from '@/components/DialogConfirmDelete.vue';
import axios from 'axios';

type tTranDocs = {
  id: number;
  templateName: string;
  signTime: string;
};

export default Vue.extend({
  name: 'WorkplaceTransactionDetail',
  components: { DialogConfirmDelete },
  props: {
    tranUUID: String,
    iwpMandatory: Number,
    visitorID: Number,
    tranSignStatus: Number,
    dialogTranDetail: Boolean,
  },
  data: () => ({
    tranDocs: [] as tTranDocs[],
    deleteConfirm: false,
    parentTran: {} as any,
    childTran: {} as any,
    mdiCheck: mdiCheck,
    mdiPrinter: mdiPrinter,
    mdiClose: mdiClose,
  }),
  computed: {
    openTranDetail: {
      get() {
        this.dialogTranDetail ? this.getParenAndChildData() : '';
        this.dialogTranDetail ? this.getVisitorDocuments() : '';
        return this.dialogTranDetail;
      },
      set(val: Boolean) {
        this.$emit('dialogTranDetail', val);
      },
    } as DefaultComputed,
  },

  methods: {
    getParenAndChildData() {
      this.parentTran = this.$store.state.websocket.transactions.find((item: any) => item.uuid === this.tranUUID);
      this.childTran = this.$store.state.websocket.transactions.find((item: any) => item.parent === this.tranUUID);
    },
    formatDate(date: string, format: string) {
      if (date === null || date === '') {
        return '';
      }
      return this.$moment(date).format(format);
    },
    getVisitorDocument(id: any) {
      if (this.$store.state.appMode === 'electron') {
        const link = document.createElement('a');
        link.href = `/api/v1/trandoc/${id}`;
        link.setAttribute('download', 'tranDoc.pdf');
        document.body.appendChild(link);
        link.click();
      } else {
        let printWin = window.open(
          `/api/v1/trandoc/${id}`,
          'portunus-print-window',
          'location=no,titlebar=no,toolbar=no,status=no,menubar=no,width=1024,height=900',
        );
        if (printWin === null) {
          alert(this.$i18n.t('msg.popupRequired'));
          return;
        }
        printWin!.addEventListener(
          'load',
          () => {
            printWin!.focus();
            // printWin!.print();
          },
          false,
        );
      }
    },
    requestConfirmAgain() {
      axios
        .put(`/api/v1/transaction/confirmagain/${this.tranUUID}`)
        .then(() => {
          this.$emit('dialogTranDetail', false);
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    deleteTransaction() {
      axios
        .delete(`/api/v1/transaction/${this.tranUUID}`)
        .then(() => {
          this.$emit('dialogTranDetail', false);
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    getVisitorDocuments() {
      axios
        .get(`/api/v1/visitordocuments/${this.visitorID}`)
        .then((response) => {
          this.tranDocs = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
  },
});
</script>
